import './register-customer.css'
import * as React from 'react'
import RegisterForm from '../../components/register-form/register-form'

/**
 * Register Customer Component.
 * Represents the customer registration page.
 *
 * @returns {React.ReactElement} - Register Customer Component.
 */
const RegisterCustomer = () => {
  return <RegisterForm />
}

export default RegisterCustomer
